import { render, staticRenderFns } from "./LaboratoriesListLabs.vue?vue&type=template&id=915aeebc&"
import script from "./LaboratoriesListLabs.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LaboratoriesListLabs.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915aeebc')) {
      api.createRecord('915aeebc', component.options)
    } else {
      api.reload('915aeebc', component.options)
    }
    module.hot.accept("./LaboratoriesListLabs.vue?vue&type=template&id=915aeebc&", function () {
      api.rerender('915aeebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/LaboratoriesList/components/LaboratoriesListLabs.vue"
export default component.exports